export default __webpack_public_path__ + "static/media/burger-3-350w.553cf3e3.png";